export class AgencyConfigData {
  appName: string = '';
  appNameShort: string = '';
  name: string = '';
  phone: string = '';
  url: string = '';
  addressL1: string = '';
  addressL2: string = '';
  addressCountry: string = '';
  logo: string = '';
  logoLarge: string = '';
  locupa2: string = '';
  platformType: string = '';
}
